/**
 * apply sticky functionality to .header selector
 */
import { isExpEditor } from './../lib/lib'

class Header {
  constructor(element) {
    if (!element) {
      return false
    }

    if (isExpEditor()) {
      return false
    }

    this.header = jQuery(element)

    jQuery('.header__list__search', this.header).on('click', () => {
      jQuery(document).trigger('search')
    })
    jQuery('.header__wrapper-mob__btn-search', this.header).on('click', () => {
      jQuery(document).trigger('search')
    })

    // device menu
    this.showMenu = false
    this.noScrollClassName = 'noscroll-devices'

    jQuery('.header__wrapper-mob__btn-open-menu', this.header).on(
      'click',
      () => {
        this._openCloseMenu(true)
      }
    )
    jQuery('.header__wrapper-mob__btn-close-menu', this.header).on(
      'click',
      () => {
        this._openCloseMenu(false)
      }
    )
  }

  _openCloseMenu(bool) {
    this.showMenu = bool
    this._toggleDeviceMenu()
  }

  _toggleDeviceMenu() {
    if (this.showMenu) {
      jQuery('body, html').addClass(this.noScrollClassName)
    } else {
      jQuery('body, html').removeClass(this.noScrollClassName)
    }
  }
}
export default Header
